module.exports = __webpack_public_path__ + "images/edit-columns-ccfa352e.svg";